<div class="health-indicator">
	<div class="status-text">
		{{healthText()}}
		<div class="circle status-blank-bg" [class.status-ok-bg]="level === 1 || level === 2" [class.status-warning-bg]="level === 3" [class.status-error-bg]="level === 4">
			<i *ngIf="level === 1" class="icon-ok"></i>
			<i *ngIf="level === 3 || level === 4" class="icon-attention-alt"></i>
		</div>
	</div>
	<div class="status-bars">
		<div class="bar status-blank-bg" [class.status-ok-bg]="level === 1 || level === 2"></div>
		<div class="bar status-blank-bg" [class.status-warning-bg]="level === 3"></div>
		<div class="bar status-blank-bg" [class.status-error-bg]="level === 4"></div>
	</div>
</div>